import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    main: {
        isDrawerOpen: false,
        isLoading: false,
        drawerPageName: "login",
    },
};
const slice = createSlice({
    name: "main",
    initialState,
    reducers: {
        setDrawerOpen: (state, action) => {
            state.main.isDrawerOpen = action.payload;
        },
        setDrawerPage: (state, action) => {
            state.main.drawerPageName = action.payload;
        },
        setMainModal: (state, action) => {
            state.main.modal = action?.payload ?? null;
        },
        setContentModal: (state, action) => {
            state.main.contentModal = action?.payload ?? null;
        },
        setMainLoader: (state, action) => {
            state.main.isLoading = action.payload;
        },
    },
});
export const { setDrawerOpen, setDrawerPage, setMainModal, setContentModal, setMainLoader } = slice.actions;
export default slice.reducer;
